export default __webpack_public_path__ + "static/media/account.911436d1.svg";